import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AdminContext } from '../../contexts/admin.context';

import DownloadItem from '../common/DownloadItem';

const DownloadSection = ({ name, children, textSize = 'text-xl' }) => {
  return (
    <section className="mb-8">
      <h3
        className={`text-gray-primary mb-2 ${textSize}`}
        dangerouslySetInnerHTML={{
          __html: name
        }}
      />
      {children}
    </section>
  );
};

const PDFDownloads = () => {
  const { t, i18n } = useTranslation();

  const { themeId, teamType, tRegion, user } = useContext(AdminContext);

  const mod = !user?.administrator && user?.moderator ? 'mod' : '';

  const [list, setList] = useState([]);
  const [showText, setShowText] = useState(0);

  useEffect(() => {
    setList(t(`${teamType}.pdfDownloads`, { returnObjects: true })?.list);
  }, [i18n.language]);

  return (
    <>
      {list?.map &&
        list?.map((item, mainIndex) => {
          // Check if this download section is disabled here
          if (
            item?.heading?.[`${tRegion}_${mod}`] !== undefined &&
            item?.heading?.[`${tRegion}_${mod}`] === ''
          )
            return null;
          if (item?.heading?.[tRegion] !== undefined && item?.heading?.[tRegion] === '')
            return null;
          if (
            item?.heading?.[`${themeId}_${mod}`] !== undefined &&
            item?.heading?.[`${themeId}_${mod}`] === ''
          )
            return null;
          if (item?.heading?.[themeId] !== undefined && item?.heading?.[themeId] === '')
            return null;
          if (
            item?.heading?.[`default_${mod}`] !== undefined &&
            item?.heading?.[`default_${mod}`] === ''
          )
            return null;
          if (item?.heading?.default !== undefined && item?.heading?.default === '') return null;

          const name =
            item?.heading?.[`${tRegion}_${mod}`] ||
            item?.heading?.[tRegion] ||
            item?.heading?.[`${themeId}_${mod}`] ||
            item?.heading?.[themeId] ||
            item?.heading?.[`default_${mod}`] ||
            item?.heading?.default;

          return (
            <DownloadSection key={mainIndex + name} textSize={'text-lg font-semibold'} name={name}>
              {item?.downloads?.constructor === Array &&
                item?.downloads?.length > 0 &&
                item?.downloads?.map((download, index) => {
                  const infoItemIndex = `${mainIndex}.${index}`;

                  const regionModName = download?.name?.[`${tRegion}_${mod}`];
                  const regionName = download?.name?.[tRegion];
                  const themeIdModName = download?.name?.[`${themeId}_${mod}`];
                  const themeIdName = download?.name?.[themeId];
                  const defaultModName = download?.name?.[`default_${mod}`];
                  const defaultName = download?.name?.default;

                  // Disabling by just not defining the org specific var and not even default var
                  let downloadDisabled =
                    (defaultName == undefined &&
                      regionModName == undefined &&
                      regionName == undefined &&
                      themeIdModName == undefined &&
                      themeIdName == undefined &&
                      defaultModName == undefined) ||
                    (regionModName !== undefined && regionModName === '') ||
                    (regionName !== undefined && regionName === '') ||
                    (themeIdModName !== undefined && themeIdModName === '') ||
                    (themeIdName !== undefined && themeIdName === '') ||
                    (defaultModName !== undefined && defaultModName === '') ||
                    (defaultName !== undefined && defaultName === '');

                  if (downloadDisabled) return null;

                  const downloadName =
                    regionModName ||
                    regionName ||
                    themeIdModName ||
                    themeIdName ||
                    defaultModName ||
                    defaultName;

                  const regionModLink = download?.link?.[`${tRegion}_${mod}`];
                  const regionLink = download?.link?.[tRegion];
                  const themeIdModLink = download?.link?.[`${themeId}_${mod}`];
                  const themeIdLink = download?.link?.[themeId];
                  const defaultModLink = download?.link?.[`default_${mod}`];
                  const defaultLink = download?.link?.default;

                  const downloadLink =
                    regionModLink ||
                    regionLink ||
                    themeIdModLink ||
                    themeIdLink ||
                    defaultModLink ||
                    defaultLink;

                  const regionModInfo = download?.info?.[`${tRegion}_${mod}`];
                  const regionInfo = download?.info?.[tRegion];
                  const themeIdModInfo = download?.info?.[`${themeId}_${mod}`];
                  const themeIdInfo = download?.info?.[themeId];
                  const defaultModInfo = download?.info?.[`default_${mod}`];
                  const defaultInfo = download?.info?.default;

                  const downloadInfo =
                    regionModInfo ||
                    regionInfo ||
                    themeIdModInfo ||
                    themeIdInfo ||
                    defaultModInfo ||
                    defaultInfo;

                  return (
                    <>
                      <DownloadItem
                        key={infoItemIndex}
                        name={downloadName}
                        link={downloadLink}
                        setShowText={setShowText}
                        directLink={true}
                        index={infoItemIndex}
                        isInfo={true}
                      />
                      {showText === infoItemIndex && (
                        <p
                          className={`text-gray-primary mb-2`}
                          dangerouslySetInnerHTML={{
                            __html: downloadInfo
                          }}></p>
                      )}
                    </>
                  );
                })}
            </DownloadSection>
          );
        })}
    </>
  );
};

export default PDFDownloads;
